import { useWS } from "@hooks";
import { useEffect, useRef, useState } from "react";

export function useWatchUserWsEvent({
  onMessage,
  eventName,
  onConnect = () => {},
}) {
  const { connectWS, webSockets } = useWS();
  const userUuid = localStorage.getItem("user_uuid");
  const wsRef = useRef(null);
  const [resetRef, setResetRef] = useState(true);

  const handler = (e) => {
    let message = JSON.parse(e.data);
    if (!eventName || message.event === eventName) {
      onMessage(message);
    }
  };

  useEffect(() => {
    if (!userUuid) {
      return;
    }
    if (!wsRef.current) {
      wsRef.current = connectWS(`user/${userUuid}`);
      if (!wsRef.current) {
        // websocket connection is already loading
        return;
      }
      onConnect();
    }

    setResetRef(false);
    wsRef.current.addEventListener("message", handler);
    return () => {
      wsRef.current?.removeEventListener("message", handler);
    };
  }, [userUuid, onMessage, resetRef]);

  useEffect(() => {
    if (!userUuid) {
      return;
    }
    // this exists to resync the local ref on disconnect / reconnect.
    // We can't just use the webSockets[`user/${userUuid}`] object directly
    // because we want to let it handle the reconnect logic external to this component
    if (
      webSockets[`user/${userUuid}`] === null &&
      wsRef.current !== null
    ) {
      wsRef.current = null;
    } else if (
      webSockets[`user/${userUuid}`] !== null &&
      wsRef.current === null
    ) {
      setResetRef(true);
    }
  }, [webSockets[`user/${userUuid}`]]);
}
